import { render, staticRenderFns } from "./QrProduct.vue?vue&type=template&id=55d45ef2&"
import script from "./QrProduct.vue?vue&type=script&lang=ts&"
export * from "./QrProduct.vue?vue&type=script&lang=ts&"
import style0 from "./QrProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports